interface PassageStorageState {
  isReload: boolean
  passageDetail: {
    isVisible: boolean
    edp_idx: string | number
  }
  passageInput: {
    isVisible: boolean
    edp_idx: string | number
  }
  moveToFolder: {
    isVisible: boolean
    move_edp_idx: string | number
  }
  createFolder: {
    isVisible: boolean
  }
}

// GA 이벤트 추적을 위한 Analytics 컴포저블
let analyticsComposable: any = null
let appStore: any = null

// 클라이언트 사이드에서만 Analytics 초기화
const initializeAnalytics = () => {
  if (process.client && !analyticsComposable) {
    try {
      analyticsComposable = useAnalytics()
      appStore = useAppStore()
    } catch (error) {
      console.warn('Analytics initialization failed:', error)
    }
  }
}

// GA 이벤트 추적 헬퍼 함수
const trackPassageStorageEvent = (eventName: string, eventData: any) => {
  try {
    if (analyticsComposable?.trackEvent && appStore?.user) {
      analyticsComposable.trackEvent(eventName, {
        ...eventData,
        um_idx: appStore.user.UM_IDX ?? '',
        timestamp: new Date().toISOString()
      })
    }
  } catch (error) {
    console.warn('GA passage storage event tracking failed:', error)
  }
}

export const usePassageStorage = () => {
  const state = useState<PassageStorageState>('passageStorage', () => ({
    isReload: false,
    passageDetail: {
      isVisible: false,
      edp_idx: '',
    },
    passageInput: {
      isVisible: false,
      edp_idx: '',
    },
    moveToFolder: {
      isVisible: false,
      move_edp_idx: '',
    },
    createFolder: {
      isVisible: false,
    },
  }))
  
  // Analytics 초기화
  initializeAnalytics()
  const reload = () => {
    state.value.isReload = true
    /*    setTimeout(() => {
      state.value.isReload = false
    }, 1000)*/
  }

  const preventScroll = () => {
    if (process.client) {
      document.body.style.overflow = 'hidden'
    }
  }

  const allowScroll = () => {
    if (process.client) {
      document.body.style.overflow = ''
    }
  }

  /* 지문 상세 */
  const openPassageDetail = (idx: any) => {
    state.value.passageDetail.isVisible = true
    state.value.passageDetail.edp_idx = idx
    
    // GA 이벤트: 지문 상세 팝업 열기
    trackPassageStorageEvent('passagestorage_passage_detail_opened', {
      event_category: 'popup_interaction',
      popup_type: 'passage_detail',
      passage_id: idx,
      was_visible: state.value.passageDetail.isVisible
    })
    
    preventScroll()
  }
  const closePassageDetail = () => {
    const previousIdx = state.value.passageDetail.edp_idx
    
    state.value.passageDetail.isVisible = false
    state.value.passageDetail.edp_idx = ''
    
    // GA 이벤트: 지문 상세 팝업 닫기
    trackPassageStorageEvent('passagestorage_passage_detail_closed', {
      event_category: 'popup_interaction',
      popup_type: 'passage_detail',
      passage_id: previousIdx,
      close_method: 'manual'
    })
    
    allowScroll()
  }

  /* 지문 수정/추가 */
  const openPassageInput = () => {
    state.value.passageInput.isVisible = true
    
    // GA 이벤트: 지문 수정 팝업 열기
    trackPassageStorageEvent('passagestorage_passage_input_opened', {
      event_category: 'popup_interaction',
      popup_type: 'passage_input',
      action: 'edit_passage',
      was_visible: state.value.passageInput.isVisible
    })
    
    preventScroll()
  }
  const closePassageInput = () => {
    const previousIdx = state.value.passageInput.edp_idx
    
    state.value.passageInput.isVisible = false
    state.value.passageInput.edp_idx = ''
    
    // GA 이벤트: 지문 수정 팝업 닫기
    trackPassageStorageEvent('passagestorage_passage_input_closed', {
      event_category: 'popup_interaction',
      popup_type: 'passage_input',
      passage_id: previousIdx,
      close_method: 'manual'
    })
    
    allowScroll()
  }

  /* 폴더 이동 */
  const openMoveToFolder = (idx: any) => {
    state.value.moveToFolder.move_edp_idx = idx
    state.value.moveToFolder.isVisible = true
    
    // GA 이벤트: 폴더 이동 팝업 열기
    trackPassageStorageEvent('passagestorage_move_folder_opened', {
      event_category: 'popup_interaction',
      popup_type: 'move_to_folder',
      passage_id: idx,
      action: 'move_passage',
      was_visible: state.value.moveToFolder.isVisible
    })
    
    preventScroll()
  }
  const closeMoveToFolder = () => {
    const previousIdx = state.value.moveToFolder.move_edp_idx
    
    state.value.moveToFolder.move_edp_idx = ''
    state.value.moveToFolder.isVisible = false
    
    // GA 이벤트: 폴더 이동 팝업 닫기
    trackPassageStorageEvent('passagestorage_move_folder_closed', {
      event_category: 'popup_interaction',
      popup_type: 'move_to_folder',
      passage_id: previousIdx,
      close_method: 'manual'
    })
    
    allowScroll()
  }

  /* 폴더 추가 */
  const openCreateFolder = () => {
    state.value.createFolder.isVisible = true
    
    // GA 이벤트: 폴더 생성 팝업 열기
    trackPassageStorageEvent('passagestorage_create_folder_opened', {
      event_category: 'popup_interaction',
      popup_type: 'create_folder',
      action: 'create_new_folder',
      was_visible: state.value.createFolder.isVisible
    })
    
    preventScroll()
  }
  const closeCreateFolder = () => {
    state.value.createFolder.isVisible = false
    
    // GA 이벤트: 폴더 생성 팝업 닫기
    trackPassageStorageEvent('passagestorage_create_folder_closed', {
      event_category: 'popup_interaction',
      popup_type: 'create_folder',
      close_method: 'manual'
    })
    
    allowScroll()
  }
  return {
    state,
    reload,
    openPassageDetail,
    closePassageDetail,

    openPassageInput,
    closePassageInput,

    openMoveToFolder,
    closeMoveToFolder,

    openCreateFolder,
    closeCreateFolder,
  }
}
